angular.module('app').controller('EventsCtrl', function($controller, $scope, $http, $rootScope, $location, $cookies) {
    "ngInject";

    var main = this;
    main.name = 'event';
    angular.extend(main, $controller('ListCtrl', {'$scope': $scope, 'main': main}));

    main.now = new Date();
    main.overdue = function(date) {
        return moment(date) < main.now;
    }
    main.dueSoonDate = moment().add(7, 'days');
    main.dueSoon = function(date) {
        return moment(date) < main.dueSoonDate;
    }
    main.deliverableByName = function(item, name) {
        if(!item.deliverableMap) {
            item.deliverableMap = item.deliverables.reduce(
                (d, el, idx) => {d[el.name] = el; return d},
                {}
            );
        }

        return item.deliverableMap[name];
    }

    if($location.search().showStatusGrid == true) {
        main.showStatusGrid = true;
    }

    main.percent_gals_ordered = {};
    main.percent_gals_viewed = {};
    main.totals = {};
    main.session_fees = {};
    main.fetching = new Set();

    main.dateRange = $cookies.get('eventDateRange') || 'thisSeason';

    main.setThisMonth = function() {
        var today = moment();
        main.query.start_date = today.clone().date(1).startOf('day');
        main.query.end_date = today.clone().endOf('month').endOf('day');
    };

    main.setLastMonth = function() {
        var lastMonth = moment().subtract(1, 'months');
        main.query.start_date = lastMonth.clone().date(1).startOf('day');
        main.query.end_date = lastMonth.clone().endOf('month').endOf('day');
    };

    main.getSeason = function(date) {
        if(date.month() >= 6) {
            main.query.start_date = date.clone().month(6).startOf('month');
            main.query.end_date = date.clone().endOf('year');
        } else {
            main.query.start_date = date.clone().startOf('year');
            main.query.end_date = date.clone().month(5).endOf('month');
        }
    };

    main.setThisSeason = function() {
        var today = moment();
        return main.getSeason(today);
    };

    main.setNextSeason = function() {
        var day = moment().add(6, 'months');
        return main.getSeason(day);
    };

    main.setLastSeason = function() {
        var lastSeason = moment().subtract(6, 'months');
        return main.getSeason(lastSeason);
    };

    main.setSeason = function() {
        if (main.dateRange == 'thisSeason') {
            main.setThisSeason();
        } else if (main.dateRange == 'lastSeason') {
            main.setLastSeason();
        } else if (main.dateRange == 'nextSeason') {
            main.setNextSeason();
        } else if (main.dateRange == 'thisMonth') {
            main.setThisMonth();
        } else if (main.dateRange == 'lastMonth') {
            main.setLastMonth();
        } else if (main.dateRange == 'all') {
            main.query.start_date = null;
            main.query.end_date = null;
        }
    }

    main.updateDate = function() {
        main.setSeason();
        main.load();
        $cookies.put('eventDateRange', main.dateRange);
    };

    main.setSeason();

    main.update_attribute = function(item, attribute) {
        var data = {'school_id': item.school_id};
        data[attribute] = item[attribute];
        $http.put('/api/v1/admin/event/' + item.id, data)
    }

    $scope.$watch('main.items', function() {
        if(main.items && main.items.length > 0) {
            var ids_to_fetch = main.items
                .filter((item) => { return ! main.fetching.has(item.id); })
                .map((item) => { return item.id });
            if(ids_to_fetch.length > 0) {
                ids_to_fetch.forEach(function(id) {
                    main.fetching.add(id);
                });

                if($rootScope.is_superadmin || $rootScope.is_owner || $rootScope.report_access || $rootScope.stats_access) {
                    $http({
                        'method': 'GET',
                        'url': '/api/v1/admin/event/stats',
                        'params': {'ids': ids_to_fetch}
                    }).then( 
                        function(response) {
                            main.percent_gals_ordered = Object.assign(main.percent_gals_ordered, response.data.percent_gals_ordered);
                            main.percent_gals_viewed = Object.assign(main.percent_gals_viewed, response.data.percent_gals_viewed);
                            main.totals = Object.assign(main.totals, response.data.totals);
                            main.session_fees = Object.assign(main.session_fees, response.data.session_fees);
                        }, 
                        function() {
                            ids_to_fetch.forEach(function(id) {
                                main.fetching.delete(id);
                            });
                        }
                    )
                }
            }
        }
    });
});
